import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import { ArtistSidePanel } from "components/SidePanel/Company/CompanySidePanel";

export const RemovableArtist = (props: RemovableProps<server.dto.ArtistSmall>) => {

  return <RemovableLabel
    {...props}
  >
    <ArtistSidePanel
      companyId={props.value.artistId}
      trigger={<a>
        {props.value.name}
      </a>}
    />
  </RemovableLabel>;
};